import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { Splide, SplideSlide } from '@splidejs/react-splide'
import '@splidejs/react-splide/css'

interface HorizontalSliderProps {
  children: React.ReactNode
}

const HorizontalSlider: React.FC<HorizontalSliderProps> = ({ children }) => {
  const BASE_WIDTH = 390
  const BASE_GAP = 14

  const wrapperRef = useRef<HTMLDivElement>(null)
  // null = 아직 폭 미측정. 측정 전엔 Splide를 렌더하지 않아
  // 잘못된 gap으로 초기화됐다가 재배치되는 '모이는' 현상을 없앤다.
  const [gap, setGap] = useState<number | null>(null)

  const computeGap = (containerWidth: number): number =>
    BASE_GAP * (containerWidth / BASE_WIDTH)

  // 첫 페인트 전에 실제 폭으로 gap 확정 → 마운트 후 gap(14)→계산값으로
  // 카드 간격이 '모이는' 리플로우 방지 (특히 새로 여는 바텀시트에서 도드라짐).
  useLayoutEffect(() => {
    const el = wrapperRef.current
    const width = el ? el.getBoundingClientRect().width : 0
    setGap(width > 0 ? computeGap(width) : BASE_GAP)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      const width = entries[0].contentRect.width
      if (width > 0) {
        setGap(computeGap(width))
      }
    })

    if (wrapperRef.current) {
      observer.observe(wrapperRef.current)
    }

    return () => observer.disconnect()
  }, [])

  return (
    <div ref={wrapperRef} className="w-full">
      {gap !== null && (
        <Splide
          options={{
            type: 'slide',
            perPage: 2,
            gap,
            pagination: false,
            arrows: false,
            drag: true,
            snap: true,
            rewind: false,
            speed: 400,
            easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
          }}
        >
          {React.Children.map(children, (child, index) => (
            <SplideSlide key={index}>{child}</SplideSlide>
          ))}
        </Splide>
      )}
    </div>
  )
}

export default HorizontalSlider
